'use client';

import { Button, Stack, Typography } from '@unity/cloud-ui';
import type { ProductHeaderDataType } from '@/lib/content-loader/types';
import { VersionPicker } from '@/components/sidebar/components/version-picker';
import { NavigationLink } from '@/components/navigation-link';

export const ProductHeaderDesktop = (props: ProductHeaderDataType) => {
  const { title, quickAccess, callToAction, versions } = props;

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
      <Stack direction="row" gap={2} alignItems="center" marginLeft={1}>
        <Typography variant="h3">{title}</Typography>
        {versions && <VersionPicker versions={versions} />}
        {quickAccess?.map(({ title, href }) => (
          <Button
            color="default"
            component={NavigationLink}
            key={title}
            href={href}
            sx={{ '&:hover': { color: 'inherit' } }}
          >
            <Typography
              color="text.secondary"
              variant="h3"
              fontSize="0.875rem"
              fontWeight={500}
              lineHeight="1.75rem"
              letterSpacing={0}
            >
              {title}
            </Typography>
          </Button>
        ))}
      </Stack>
      {callToAction && (
        <Button
          variant="contained"
          color="primary"
          component={NavigationLink}
          href={callToAction.href}
          external
          sx={({ vars }) => ({ '&:hover': { color: vars.palette.primary.buttonContrastText } })}
        >
          {callToAction.title}
        </Button>
      )}
    </Stack>
  );
};
